import { useQuery } from '@tanstack/react-query'

import { useMockEnvironment } from '@contexts/mockEnv'
import { mockedOperationPosts } from '@hooks/mocks/operationPosts'
import { useFindProfile } from '@hooks/profile'
import { api } from '@services/apiClient'

interface IOperationPost {
  description: string
  isActive: boolean
  id: number
  projectIds: number[]
}

export const useFindOperationPosts = () => {
  const { isMockEnvironment } = useMockEnvironment()
  const { data: user } = useFindProfile()
  const siteId = user && user.selectedSite.id

  async function fetchOperationPosts() {
    if (!isMockEnvironment) {
      const { data } = await api.get<IOperationPost[]>(
        `sites/${siteId}/operationPosts`,
      )
      return data
    }

    return mockedOperationPosts
  }

  return useQuery({
    queryKey: ['OPERATION_POSTS'],
    queryFn: fetchOperationPosts,
  })
}
